import React from "react";
import { Row, Col, Checkbox, Select } from "antd";
import "../styles.css";

const spanstyles = {
  marginRight: 8,
};

export const getFlatFileDefaultConfigs = {
  flat_file_view: false,
  flat_file_check_in: false,
  flat_file_print: false,
  flat_file_delete: false,
  flat_file_upload: false,
  flat_file_re_index: false,
  flat_file_download: false,
  flat_file_full_text_search: false,
  flat_file_version_history: false,
  flat_file_version_val: undefined,
  flat_file_version_rollback: false,
  flat_file_share: false,
  // flat_file_domains:[]
};

function FlatFileSettings(props) {
  return (
    <div className="app_config_checkbox_class2">
      <Row>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(e.target.checked, props._id, "flat_file_view")
              }
              checked={props.config.flat_file_view}
            />
          </span>
          <span style={spanstyles}>View</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_check_in"
                )
              }
              checked={props.config.flat_file_check_in}
            />
          </span>
          <span style={spanstyles}>Check In</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_print"
                )
              }
              checked={props.config.flat_file_print}
            />
          </span>
          <span style={spanstyles}>Print</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_delete"
                )
              }
              checked={props.config.flat_file_delete}
            />
          </span>
          <span style={spanstyles}>Delete</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_upload"
                )
              }
              checked={props.config.flat_file_upload}
            />
          </span>
          <span style={spanstyles}>Upload</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_re_index"
                )
              }
              checked={props.config.flat_file_re_index}
            />
          </span>
          <span style={spanstyles}>Re-Index</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_download"
                )
              }
              checked={props.config.flat_file_download}
            />
          </span>
          <span style={spanstyles}>Download</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_full_text_search"
                )
              }
              checked={props.config.flat_file_full_text_search}
            />
          </span>
          <span style={spanstyles}>Full Text Search</span>
        </Col>
      </Row>
      <Row>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_version_history"
                )
              }
              checked={props.config.flat_file_version_history}
            />
          </span>
          <span style={spanstyles}>Version History</span>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <div style={spanstyles}>
            <Select
              value={props.config.flat_file_version_val}
              style={{ width: "100%" }}
              showSearch={true}
              filterOption={(input, option) => {
                return (
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                );
              }}
              placeholder="Please Select"
              onChange={(e) =>
                props.updateValue(e, props._id, "flat_file_version_val")
              }
            >
              <Select.Option value={"Show All"}>Show All</Select.Option>
            </Select>
          </div>
        </Col>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_version_rollback"
                )
              }
              checked={props.config.flat_file_version_rollback}
            />
          </span>
          <span style={spanstyles}>Version Rollback</span>
        </Col>
      </Row>
      <Row>
        <Col xxl={2} xl={3} lg={4} sm={6}>
          <span style={spanstyles}>
            <Checkbox
              onChange={(e) =>
                props.updateValue(
                  e.target.checked,
                  props._id,
                  "flat_file_share"
                )
              }
              checked={props.config.flat_file_share}
            />
          </span>
          <span style={spanstyles}>Share</span>
        </Col>
        {/* <Col xxl={4} xl={6} lg={8} sm={12}>
                    <div style={spanstyles}><Select value={props.config.flat_file_domains} 
                    showSearch={true}
                    filterOption={(input, option) =>{
                        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }} style={{width:"100%"}} mode="multiple" placeholder="Please Select" onChange={e=>props.updateValue(e,props._id,'flat_file_domains')}>
                        <Select.Option value="marriott.com">marriott.com</Select.Option>
                        <Select.Option value="mydigitaloffice.ca">mydigitaloffice.ca</Select.Option>
                        <Select.Option value="holidayinn.com">holidayinn.com</Select.Option>
                        <Select.Option value="marriotthotels.com">marriotthotels.com</Select.Option>
                        <Select.Option value="hotelsholdings.com">hotelsholdings.com</Select.Option>
                        <Select.Option value="marriottsuites.com">marriottsuites.com</Select.Option>
                        <Select.Option value="deerpark.com">deerpark.com</Select.Option>
                    </Select></div>
                </Col> */}
      </Row>
    </div>
  );
}

export default FlatFileSettings;
